import styled from "styled-components";
import { theme } from "styles/theme";
import { AppButton } from "./AppButton";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 3rem 1.5rem;
  text-align: center;
  color: ${theme.colors.textSecondary};
`;

const Message = styled.p`
  margin: 0;
  max-width: 28rem;
  line-height: 1.5;
`;

interface EmptyStateProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({
  message,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <Wrapper role="status">
      <Message>{message}</Message>
      {actionLabel && onAction && (
        <AppButton type="button" onClick={onAction}>
          {actionLabel}
        </AppButton>
      )}
    </Wrapper>
  );
}
